'use strict';

function icPart(str) {
  return str.split('').map(function(c) { return '(?:' + [c.toUpperCase(), c.toLowerCase()].join('|') + ')'; }).join('')
}

module.exports = icPart;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inflected/lib/icPart.js
// module id = 1125
// module chunks = 0